import update from 'immutability-helper'

import {
  // PLOP_APPEND_PATTERN_ANCHOR_ACTIONS_IMPORT
  SUBMIT_SERVER_LOGOUT,
  SUBMIT_SERVER_LOGOUT_SUCCESS,
  SUBMIT_SERVER_LOGOUT_FAILURE,
  CLEAR_SUBMIT_SERVER_LOGOUT,
  GET_CURRENT_USER_PROFILE,
  GET_CURRENT_USER_PROFILE_SUCCESS,
  GET_CURRENT_USER_PROFILE_FAILURE,
  UPDATE_CURRENT_USER_PROFILE,
  UPDATE_CURRENT_USER_PROFILE_SUCCESS,
  UPDATE_CURRENT_USER_PROFILE_FAILURE,
  CLEAR_UPDATE_CURRENT_USER_PROFILE,
  CREATE_CURRENT_USER_SELF_ACCOUNT,
  UPDATE_CURRENT_USER_SELF_ACCOUNT,
  SET_USER_ACCOUNT_SETUP_MODE,
  SET_SELECTED_PLATFORM,
  SET_SEARCH,
  CLEAR_SEARCH,
  APPROVE_PLATFORM_CONNECTION,
  GET_BANNERS,
  GET_BANNERS_SUCCESS,
  GET_BANNERS_FAILURE,
  SET_SELECTED_SELF_ACCOUNT,
  GET_ASYNC_SESSION,
  GET_ASYNC_SESSION_SUCCESS,
  GET_ASYNC_SESSION_FAILURE,
  CLEAR_ASYNC_SESSION,
  SET_THEME_COLOR,
  SET_THEME_WAS_PRESELECTED,
  SET_PDF_GENERATION,
  SET_NEW_STYLES_THEME_ENABLED
} from '../actions/app'

import { getParameterFromPath } from '../../helpers/url'
import { updateItem } from '../../helpers/reducerHelpers'
import { initialThemeColor } from '../../helpers/other'
import { getInitialPlatform } from '../../helpers/handlePlatformSelection'
import { getInitialSelfAccount } from '../../helpers/handleSelfAccountSelection'

import { ROUTE_PARAMS } from '../../constants/routes'
import { INITIAL_CREATE_REDUCER, INITIAL_GET_REDUCER, INITIAL_GET_RESULTS_REDUCER } from '../../constants/reducer'
import { getLocalStorage } from '../../helpers/storage'

const selfAccountFromPath = parseInt(getParameterFromPath(ROUTE_PARAMS.selfAccount))

export const SELECTED_PLATFORM = 'selectedPlatform'
export const SELECTED_SELF_ACCOUNT = 'selectedSelfAccount'
export const ENABLED_NEW_THEME = 'isNewThemeEnabled'

const initialState = {
  // PLOP_APPEND_PATTERN_ANCHOR_INITIAL_REDUCER
  userProfile: INITIAL_GET_REDUCER,
  updateUserProfile: {
    isLoading: false,
    wasUpdated: false,
    error: {}
  },
  submitServerLogout: INITIAL_CREATE_REDUCER,
  [SELECTED_PLATFORM]: getInitialPlatform(),
  [SELECTED_SELF_ACCOUNT]: selfAccountFromPath,
  isUserAccountSetupMode: false,
  searchTerm: {},
  bannersData: INITIAL_GET_RESULTS_REDUCER,
  asyncSession: INITIAL_GET_REDUCER,
  themeColor: initialThemeColor,
  themeWasPreselected: false,
  isNewStylesThemeEnabled: getLocalStorage(ENABLED_NEW_THEME, true) || false,
  pdfGeneration: false
}

export default function app(state = initialState, action) {
  switch (action.type) {
    // PLOP_APPEND_PATTERN_ANCHOR_REDUCERS
    case GET_CURRENT_USER_PROFILE:
      return update(state, {
        userProfile: {
          $merge: {
            isLoading: true,
            wasLoaded: false
          }
        }
      })
    case GET_CURRENT_USER_PROFILE_SUCCESS:
      return update(state, {
        userProfile: {
          $merge: {
            isLoading: false,
            data: action.userData,
            wasLoaded: true
          }
        },
        // initial account should be set only after validation of accounts from BE
        [SELECTED_SELF_ACCOUNT]: { $set: getInitialSelfAccount(action.userData.accounts, state[SELECTED_SELF_ACCOUNT]) }
      })
    case GET_CURRENT_USER_PROFILE_FAILURE:
      return update(state, {
        userProfile: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    // Submit server logout
    case SUBMIT_SERVER_LOGOUT:
      return update(state, {
        submitServerLogout: { $merge: { isLoading: true } }
      })
    case SUBMIT_SERVER_LOGOUT_SUCCESS:
      return update(state, {
        submitServerLogout: {
          $merge: {
            isLoading: false,
            wasCreated: true,
            data: action.data
          }
        }
      })
    case SUBMIT_SERVER_LOGOUT_FAILURE:
      return update(state, {
        submitServerLogout: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_SUBMIT_SERVER_LOGOUT:
      return update(state, {
        submitServerLogout: { $set: initialState.submitServerLogout }
      })
    case UPDATE_CURRENT_USER_PROFILE:
      return update(state, {
        updateUserProfile: {
          isLoading: { $set: true }
        }
      })
    case UPDATE_CURRENT_USER_PROFILE_SUCCESS:
      return update(state, {
        userProfile: {
          $merge: {
            data: action.userData
          }
        },
        updateUserProfile: {
          isLoading: { $set: false },
          wasUpdated: { $set: true }
        }
      })
    case UPDATE_CURRENT_USER_PROFILE_FAILURE:
      return update(state, {
        updateUserProfile: {
          isLoading: { $set: false },
          error: { $set: action.error }
        }
      })
    case CLEAR_UPDATE_CURRENT_USER_PROFILE:
      return update(state, {
        updateUserProfile: { $set: initialState.updateUserProfile }
      })

    case CREATE_CURRENT_USER_SELF_ACCOUNT:
      return update(state, {
        userProfile: {
          data: {
            accounts: { $push: [action.selfAccountData] }
          }
        }
      })
    case UPDATE_CURRENT_USER_SELF_ACCOUNT:
      return update(state, {
        userProfile: {
          data: {
            accounts: { $apply: items => updateItem(items, action.selfAccountData) }
          }
        }
      })

    case SET_SELECTED_PLATFORM:
      return update(state, {
        [SELECTED_PLATFORM]: { $set: action.platform }
      })
    case SET_SELECTED_SELF_ACCOUNT:
      return update(state, {
        [SELECTED_SELF_ACCOUNT]: { $set: action.accountId }
      })
    case SET_USER_ACCOUNT_SETUP_MODE:
      return update(state, {
        isUserAccountSetupMode: { $set: action.isSetupMode }
      })
    case SET_SEARCH:
      return update(state, {
        // all searchTerms should be set within the key
        searchTerm: { $set: { [action.searchKey]: action.searchTerm } }
      })
    case CLEAR_SEARCH:
      return update(state, {
        searchTerm: { $set: initialState.searchTerm }
      })

    case APPROVE_PLATFORM_CONNECTION:
      return update(state, {
        userProfile: {
          data: {
            $merge: action.authData
          }
        }
      })
    case GET_BANNERS:
      return update(state, {
        bannersData: {
          $merge: {
            isLoading: true
          }
        }
      })
    case GET_BANNERS_SUCCESS:
      return update(state, {
        bannersData: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.bannersData.results
          }
        }
      })
    case GET_BANNERS_FAILURE:
      return update(state, {
        bannersData: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })

    // get async session
    case GET_ASYNC_SESSION:
      return update(state, {
        asyncSession: {
          $merge: {
            isLoading: true
          }
        }
      })
    case GET_ASYNC_SESSION_SUCCESS:
      return update(state, {
        asyncSession: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            data: action.sessionData
          }
        }
      })
    case GET_ASYNC_SESSION_FAILURE:
      return update(state, {
        asyncSession: {
          $merge: {
            isLoading: false,
            data: action.sessionData,
            error: action.error
          }
        }
      })
    case CLEAR_ASYNC_SESSION:
      return update(state, {
        asyncSession: { $set: initialState.asyncSession }
      })

    // theme
    case SET_THEME_COLOR:
      return update(state, {
        themeColor: { $set: action.themeColor }
      })
    case SET_THEME_WAS_PRESELECTED:
      return update(state, {
        themeWasPreselected: { $set: true }
      })
    case SET_NEW_STYLES_THEME_ENABLED:
      return update(state, {
        isNewStylesThemeEnabled: { $set: action.isEnabled }
      })
    case SET_PDF_GENERATION:
      return update(state, {
        pdfGeneration: { $set: action.isGenerating }
      })
    default:
      return state
  }
}
